import React from "react";
import MyProfile from "./MyProfile/MyProfile";
import UpdatePassword from "./UpdatePassword/UpdatePassword";
import Preference from "./Preference/Preference";
import AccessibleTabs from "../AccessibleTabs/AccessibleTabs";
import "./profile.scss";

const tabs = [
  { id: "profile", label: "Profile", Component: MyProfile },
  { id: "password", label: "Security", Component: UpdatePassword },
  { id: "preference", label: "Notification & Preferences", Component: Preference },
];

const Profile = () => {
  return (
    <div className="profileWrapper main_ele_wrapper">
      <div className="main_heading">
        <h1 id="heading-title">My Account</h1>
      </div>

      <AccessibleTabs
        tabs={tabs}
        defaultActive="profile"
        panelWrapperClass="userPassdDetail_wrapper"
        panelClassMap={{
          profile: "myprofileMedia",
          password: "mypasswordMedia",
          preference: "mypreferenceMedia",
        }}
      />
    </div>
  );
};

export default Profile;